/** @jsx jsx */
import { jsx } from '@emotion/core';
import { MenuItem } from '@material-ui/core';
import React, { Dispatch, Fragment, SetStateAction } from 'react';
import theme from '../../../../../themes/theme';
import { PageTextContentType } from '../../../../../hooks/useContentMgmt';
import { InvoiceStatus } from '../../../../../hooks/invoice-payment-portal/useInvoiceList';
import { Status } from '../../../../../__generated__/pge-types';

type FilterProps = {
  content: PageTextContentType;
  filter: (status: Status) => void;
  setOpenDrawer?: Dispatch<SetStateAction<boolean>>;
  setFilterByVal?: Dispatch<SetStateAction<string | undefined>>;
  value?: Status;
};

export const Filter = (props: FilterProps) => {
  const { content, filter, setOpenDrawer, setFilterByVal } = props;

  const handleClick = (status: Status, displayValue?: string) => {
    filter(status);
    setFilterByVal && setFilterByVal(displayValue);
    setOpenDrawer && setOpenDrawer(false);
  };

  const isHighlighted = (status: Status) => {
    return status === props.value;
  };

  return (
    <Fragment>
      <MenuItem
        css={{
          fontSize: theme.spacing(2),
          ...(isHighlighted(Status.All) ? { fontWeight: 'bold' } : {}),
        }}
        onClick={() => handleClick(Status.All, content.get('ALL'))}
      >
        {content.get('ALL')}
      </MenuItem>
      <MenuItem
        css={{
          fontSize: theme.spacing(2),
          ...(isHighlighted(Status.Paid) ? { fontWeight: 'bold' } : {}),
        }}
        onClick={() => handleClick(Status.Paid, content.get('PAID'))}
      >
        {content.get('PAID')}
      </MenuItem>
      <MenuItem
        css={{
          fontSize: theme.spacing(2),
          ...(isHighlighted(Status.Unpaid)
            ? { fontWeight: 'bold' }
            : {}),
        }}
        onClick={() =>
          handleClick(
            Status.Unpaid,
            content.get('UNPAID'),
          )
        }
      >
        {content.get('UNPAID')}
      </MenuItem>
     </Fragment>
  );
};
